(function () {
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


/* eslint-disable function-paren-newline */ function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


var $0696830c520502d8$export$97f0fb808b782731 = /*#__PURE__*/ function() {
    "use strict";
    function Game2048() {
        var _this = this;
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 4;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game2048);
        this.size = size;
        this.score = 0;
        this.gameField = Array.from({
            length: this.size
        }, function() {
            return Array(_this.size).fill(0);
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game2048, [
        {
            key: "removeZeros",
            value: function removeZeros(arr) {
                return arr.filter(function(row) {
                    return row !== 0;
                });
            }
        }
    ]);
    return Game2048;
}();


var $197cd56b15c33885$var$game = new (0, $0696830c520502d8$export$97f0fb808b782731)();
var $197cd56b15c33885$var$start = document.querySelector(".start");
var $197cd56b15c33885$var$fieldHtml = document.querySelectorAll(".field-row");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-score");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".hidden");
var $197cd56b15c33885$var$winner = document.querySelector(".message-win");
var $197cd56b15c33885$var$size = $197cd56b15c33885$var$game.size;
var $197cd56b15c33885$var$score = $197cd56b15c33885$var$game.score;
var $197cd56b15c33885$var$gameField = $197cd56b15c33885$var$game.gameField;
function $197cd56b15c33885$var$addLayoutOnHtml() {
    for(var row = 0; row < $197cd56b15c33885$var$size; row++)for(var cell = 0; cell < $197cd56b15c33885$var$size; cell++){
        if ($197cd56b15c33885$var$gameField[row][cell] === 2048) $197cd56b15c33885$var$winner.classList.remove("hidden");
        var setFieldHtml = $197cd56b15c33885$var$fieldHtml[row].children[cell];
        var currentValue = setFieldHtml.textContent = $197cd56b15c33885$var$gameField[row][cell] || "";
        setFieldHtml.className = currentValue ? "field-cell field-cell--".concat(currentValue) : "field-cell";
    }
    $197cd56b15c33885$var$gameScore.innerText = $197cd56b15c33885$var$score;
}
function $197cd56b15c33885$var$addRandomNumber() {
    var row = Math.floor(Math.random() * $197cd56b15c33885$var$size);
    var cell = Math.floor(Math.random() * $197cd56b15c33885$var$size);
    if ($197cd56b15c33885$var$gameField[row][cell] === 0) $197cd56b15c33885$var$gameField[row][cell] = Math.random() < 0.1 ? 4 : 2;
    else $197cd56b15c33885$var$addRandomNumber();
}
function $197cd56b15c33885$var$checkGameOver() {
    var copyGameFiel = (0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$gameField);
    var hasMoveRL = false;
    var hasMoveUD = false;
    var comeIn = false;
    var result = copyGameFiel.every(function(r) {
        return copyGameFiel.every(function(_, i) {
            return r[i] > 0;
        });
    });
    if (result) {
        comeIn = true;
        for(var row = 0; row < 4; row++){
            var eachRow = copyGameFiel[row];
            for(var cell = 0; cell < 4; cell++)if (eachRow[cell] === eachRow[cell + 1]) hasMoveRL = true;
        }
        copyGameFiel = $197cd56b15c33885$var$transpose(copyGameFiel);
        for(var row1 = 0; row1 < 4; row1++){
            var eachRow1 = copyGameFiel[row1];
            for(var cell1 = 0; cell1 < 4; cell1++)if (eachRow1[cell1] === eachRow1[cell1 + 1]) hasMoveUD = true;
        }
    }
    if (!hasMoveRL && !hasMoveUD && comeIn) $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
}
function $197cd56b15c33885$var$transpose(arr) {
    return arr.map(function(_, index) {
        return arr.map(function(row) {
            return row[index];
        });
    });
}
function $197cd56b15c33885$var$uniteCells(row) {
    var moved = false;
    for(var i = 0; i < row.length - 1; i++){
        if (row[i] === row[i + 1]) {
            row[i] *= 2;
            row.splice(i + 1, 1);
            $197cd56b15c33885$var$score += row[i];
            moved = true;
        } else if (row[i] === 0 && row[i + 1] === 0) moved = false;
    }
    while(row.length < $197cd56b15c33885$var$size)row.push(0);
    return {
        row: row,
        moved: moved
    };
}
function $197cd56b15c33885$var$clickArrowLeft() {
    var hasMoved = false;
    for(var row = 0; row < $197cd56b15c33885$var$size; row++){
        var copyGameField = (0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$gameField[row]);
        var removeZero = $197cd56b15c33885$var$game.removeZeros($197cd56b15c33885$var$gameField[row]);
        var move = $197cd56b15c33885$var$uniteCells(removeZero);
        $197cd56b15c33885$var$gameField[row] = removeZero;
        if (move.moved || JSON.stringify(copyGameField) !== JSON.stringify(move.row)) hasMoved = true;
    }
    if (hasMoved) {
        $197cd56b15c33885$var$addRandomNumber();
        $197cd56b15c33885$var$checkGameOver();
    }
    $197cd56b15c33885$var$addLayoutOnHtml();
}
function $197cd56b15c33885$var$clickArrowRight() {
    var hasMoved = false;
    for(var row = 0; row < $197cd56b15c33885$var$size; row++){
        var copyOfGameField = (0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$gameField[row]);
        var removeZero = $197cd56b15c33885$var$game.removeZeros($197cd56b15c33885$var$gameField[row].reverse());
        var newRow = $197cd56b15c33885$var$uniteCells(removeZero);
        $197cd56b15c33885$var$gameField[row] = newRow.row.reverse();
        if (newRow.moved || JSON.stringify(copyOfGameField) !== JSON.stringify(newRow.row)) hasMoved = true;
    }
    if (hasMoved) {
        $197cd56b15c33885$var$addRandomNumber();
        $197cd56b15c33885$var$checkGameOver();
    }
    $197cd56b15c33885$var$addLayoutOnHtml();
}
function $197cd56b15c33885$var$clickArrowUp() {
    var hasMoved = false;
    $197cd56b15c33885$var$gameField = $197cd56b15c33885$var$transpose($197cd56b15c33885$var$gameField);
    for(var row = 0; row < $197cd56b15c33885$var$size; row++){
        var copyOfGameField = (0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$gameField[row]);
        var removeZero = $197cd56b15c33885$var$game.removeZeros($197cd56b15c33885$var$gameField[row]);
        var newRow = $197cd56b15c33885$var$uniteCells(removeZero);
        $197cd56b15c33885$var$gameField[row] = newRow.row;
        if (newRow.moved || JSON.stringify(copyOfGameField) !== JSON.stringify(newRow.row)) hasMoved = true;
    }
    $197cd56b15c33885$var$gameField = $197cd56b15c33885$var$transpose($197cd56b15c33885$var$gameField);
    if (hasMoved) {
        $197cd56b15c33885$var$addRandomNumber();
        $197cd56b15c33885$var$checkGameOver();
    }
    $197cd56b15c33885$var$addLayoutOnHtml();
}
function $197cd56b15c33885$var$clickArrowDown() {
    var hasMoved = false;
    $197cd56b15c33885$var$gameField = $197cd56b15c33885$var$transpose($197cd56b15c33885$var$gameField);
    for(var row = 0; row < $197cd56b15c33885$var$size; row++){
        var copyOfField = (0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$gameField[row]);
        var removeZero = $197cd56b15c33885$var$game.removeZeros($197cd56b15c33885$var$gameField[row].reverse());
        var newRow = $197cd56b15c33885$var$uniteCells(removeZero);
        $197cd56b15c33885$var$gameField[row] = newRow.row.reverse();
        if (newRow.moved || JSON.stringify(copyOfField) !== JSON.stringify(newRow.row)) hasMoved = true;
    }
    $197cd56b15c33885$var$gameField = $197cd56b15c33885$var$transpose($197cd56b15c33885$var$gameField);
    if (hasMoved) {
        $197cd56b15c33885$var$addRandomNumber();
        $197cd56b15c33885$var$checkGameOver();
    }
    $197cd56b15c33885$var$addLayoutOnHtml();
}
function $197cd56b15c33885$var$handleArrows(e) {
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$clickArrowLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$clickArrowRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$clickArrowUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$clickArrowDown();
            break;
        default:
            break;
    }
}
$197cd56b15c33885$var$start.addEventListener("click", function() {
    document.addEventListener("keydown", $197cd56b15c33885$var$handleArrows);
    $197cd56b15c33885$var$startMessage.hidden = true;
    if ($197cd56b15c33885$var$start.innerText === "Start") {
        $197cd56b15c33885$var$start.innerText = "Restart";
        $197cd56b15c33885$var$start.classList.replace("start", "restart");
    } else {
        $197cd56b15c33885$var$loseMessage.classList.add("hidden");
        $197cd56b15c33885$var$score = 0;
        $197cd56b15c33885$var$gameField = $197cd56b15c33885$var$gameField = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
    }
    $197cd56b15c33885$var$addRandomNumber();
    $197cd56b15c33885$var$addRandomNumber();
    $197cd56b15c33885$var$addLayoutOnHtml();
});

})();
//# sourceMappingURL=index.e44c1c5d.js.map
